import * as React from "react";
import { ArrowLeft, ExternalLink, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { trackActivity } from "@/utils/trackActivity";

const BRAND_RENDER_URL = "https://render.ldm.gg/";

export const BrandRenderView = ({ onBack }) => {
  React.useEffect(() => {
    trackActivity("view_module", "brand_render");
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-indigo-950 to-blue-900 flex flex-col" data-testid="brand-render-view">
      <header className="border-b border-white/10 bg-black/20 backdrop-blur-md sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 py-2 flex items-center gap-3">
          <Button
            variant="ghost"
            size="sm"
            onClick={onBack}
            data-testid="brand-render-back"
            className="text-white/80 hover:text-white hover:bg-white/10"
          >
            <ArrowLeft className="h-4 w-4 mr-1" />
            Volver
          </Button>
          <div className="h-5 w-px bg-white/20" />
          <span className="text-sm font-medium text-white/90">BrandRender — AI Visual Branding Studio</span>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-6">
        <div className="max-w-lg w-full text-center">
          <div className="inline-flex p-4 rounded-2xl bg-gradient-to-br from-blue-500 to-indigo-600 shadow-2xl shadow-blue-500/30 mb-6">
            <Sparkles className="h-10 w-10 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-3">BrandRender</h1>
          <p className="text-sm text-white/60 mb-8 leading-relaxed">
            Genera imagenes de producto con IA: bolsas, cajas y latas brandeadas.
            Editor y combinador visual integrados. BrandRender se abre en una nueva pestaña.
          </p>
          <Button
            data-testid="brand-render-open-btn"
            onClick={() => window.open(BRAND_RENDER_URL, "_blank", "noopener,noreferrer")}
            className="bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-500 hover:to-indigo-600 text-white px-8 py-6 text-base shadow-lg shadow-blue-500/20"
          >
            <ExternalLink className="h-4 w-4 mr-2" />
            Abrir BrandRender
          </Button>
          <p className="text-xs text-white/40 mt-6">render.ldm.gg · AI Visual Branding Studio · LDM</p>
        </div>
      </main>
    </div>
  );
};
